/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React, { useEffect, ReactElement } from "react";

import { DetailWrapper } from "Containers/Common/CommonContainer.styles";

import { useAuth } from "./AuthProvider";

/**
 * Login Component that prompts the users to sign-in
 * @class
 */
const Login = (): ReactElement => {
  const { onSignIn } = useAuth();

  useEffect(() => onSignIn(false), []);

  /**
   * Renders Login component
   */
  return <DetailWrapper></DetailWrapper>;
};

export default Login;
